import { Amount } from "@goodfill/domain-properties";
import { formatCurrencyAmount } from "@goodfill/format-number";
import React from "react";

export const BidAmountComponent: React.FC<{ value: Amount }> = (props) => (
  <>
    {formatCurrencyAmount({
      value: props.value.toFixed(0),
      numDecimals: 0,
    })}
  </>
);
